import { Autocomplete, Box, TextField as MuiTextField } from "@mui/material";

import { useFieldContext } from "./useAppForm";

export function AutocompleteField({
  description,
  getOptionLabel,
  getOptionValue,
  renderOptionLabel,
  selects,
  label,
  required,
  hasEmpty,
  ...props
}) {
  const field = useFieldContext();

  const options = Array.isArray(selects) ? selects : [];

  const optionValue = (option) => (typeof option === "object" && option !== null ? getOptionValue(option) : option);
  const optionLabel = (option) =>
    typeof getOptionLabel === "function" ? getOptionLabel(option) : String(option ?? "");

  return (
    <Autocomplete
      fullWidth
      options={options}
      disableClearable={hasEmpty === undefined || hasEmpty === false}
      value={options.find((option) => optionValue(option) === field.state.value) ?? null}
      onChange={(event, newValue) => field.handleChange(newValue !== null ? optionValue(newValue) : hasEmpty)}
      onBlur={field.handleBlur}
      getOptionLabel={optionLabel}
      isOptionEqualToValue={(option, value) => optionValue(option) === optionValue(value)}
      renderOption={
        typeof renderOptionLabel === "function"
          ? ({ key, ...optionProps }, option) => (
              <Box component="li" key={key ?? optionValue(option)} {...optionProps}>
                {renderOptionLabel(option)}
              </Box>
            )
          : undefined
      }
      renderInput={(params) => (
        <MuiTextField
          {...params}
          id={field.name}
          label={label}
          required={required}
          placeholder={label}
          error={field.state.meta.errors.length >= 1}
          helperText={field.state.meta.errors?.map((error) => error?.message).join(" ") || description}
        />
      )}
      {...props}
    />
  );
}
